export const calcNewAmountOnIncrement = (currentAmount, isIncrease) => {
    let amount = parseFloat(currentAmount);
    let increment, exponent = 0;

    if (isIncrease) {
        if (amount < 10) {
            increment = 1;
        } else {
            while (amount >= 100) {
                amount /= 10;
                exponent++;
            }
            increment = amount >= 50 ? 10 : 5;
        }
    } else {
        if (amount === 0) {
            return amount;
        }
        if (amount <= 10) {
            increment = 1;
        } else {
            while (amount > 100) {
                amount /= 10;
                exponent++;
            }
            increment = amount <= 50 ? 5 : 10;
        }
    }

    const isAmountInt = amount % increment === 0;
    if (isAmountInt) {
        amount = isIncrease ? amount + increment : amount - increment;
    } else {
        amount = Math.floor(amount / increment) * increment;
        if (isIncrease) {
            amount = amount + increment;
        }
    }

    amount = amount * Math.pow(10, exponent);

    return amount;
}

export const roundDepositPreset = (preset) => {
    if (preset < 10) {
        return Math.ceil(preset);
    } else if (preset <= 100) {
        return Math.ceil(preset / 5) * 5;
    } else if (preset <= 1000) {
        return Math.ceil(preset / 10) * 10;
    } else if (preset <= 10000) {
        return Math.ceil(preset / 100) * 100;
    } else if (preset <= 100000) {
        return Math.ceil(preset / 1000) * 1000;
    } else {
        return Math.ceil(preset / 10000) * 10000;
    }
}
